/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Banners_Inbox_Empty_StateInputs */

const de_banners_inbox_empty_state = /** @type {(inputs: Banners_Inbox_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Benachrichtigungen`)
};

/** @type {(inputs: Banners_Inbox_Empty_StateInputs) => LocalizedString} */
const en_banners_inbox_empty_state = de_banners_inbox_empty_state;

/**

* @param {Banners_Inbox_Empty_StateInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const banners_inbox_empty_state = /** @type {((inputs?: Banners_Inbox_Empty_StateInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Banners_Inbox_Empty_StateInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_banners_inbox_empty_state(inputs)
	return en_banners_inbox_empty_state(inputs)
});